import { useEffect, useState } from 'react';
import { Row, Col, Card, Button } from 'reactstrap';
import useDashboard from './useDashboard';
import useDataSuite from '../DataSuite/useDataSuite';
import moment from 'moment';
import DateRangePicker from '../../sharedComponents/DateRangePicker/DateRangePicker';
import SelectAllSearch from '../../sharedComponents/Select/SelectAllSearch';
import { useSelector } from 'react-redux';
import HighlightsCard from './DashboardCards/HighlightsCard';
import ProductsLocationsCard from './DashboardCards/ProductsLocationsCard';
import DashboardChartsCard from './DashboardCards/DashboardChartsCard';
import BEPDistributorListCard from './DashboardCards/BEPDistributorListCard';
import SlideDrawer from '../../sharedComponents/SlideDrawer/SlideDrawer';
import getWelcomeName from '../../sharedComponents/WelcomeName/getWelcomeName';
import { BsFillGridFill } from 'react-icons/bs';
import { FaFilter } from 'react-icons/fa';
import { InputLabel } from '@mui/material';
import { selectStyles, usStatesAndTerritoriesOptions, colors } from '../../config/constants';
import PageHeader from '../../sharedComponents/Header/PageHeader';
import SegmentOverviewCard from './DashboardCards/SegmentOverviewCard';
import ManufacturerSelect from "../../sharedComponents/ManufacturerSelect/ManufacturerSelect";


const Dashboard = () => {
  const {
    fromDate, toDate, onApplySearch, onChangeDashboardDates, onChangeSelectedStates, onChangeSelectedCategories, onChangeSelectedSegments, onChangeSelectedLocations, onChangeSelectedChildrens, onChangeSelectedDistributors, onApplyDate
  } = useDashboard.useDates();
  const { setDashboardTab } = useDashboard.useDashboard();
  const { getFilters } = useDataSuite.useDataSuite();
  const minDate = useSelector(({dates}) => dates.dashMinDate);
  const dashDateString = useSelector(({dates}) => dates.dashDateString);
  const selectedStates = useSelector(({dashboard}) => dashboard.selectedStatesFilter);
  const selectedCategory = useSelector(({dashboard}) => dashboard.selectedCategoriesFilter);
  const selectedParentLocation = useSelector(({dashboard}) => dashboard.selectedLocationsFilter);
  const selectedChildLocation = useSelector(({dashboard}) => dashboard.selectedChildrensFilter);
  const selectedDistributor = useSelector(({dashboard}) => dashboard.selectedDistributorsFilter);
  const selectedSegment = useSelector(({dashboard}) => dashboard.selectedSegmentsFilter);
  const slideDrawerContents = useSelector(({dashboard}) => dashboard.slideDrawer);
  const allFilters = useSelector(({datasuite}) => datasuite.allFilters);
  const childrenFilters = useSelector(({dashboard}) => dashboard.childrenFilters);
  var mfrName = getWelcomeName() || 'Admin';
  const selectedManufacturers = useSelector(({user}) => user.selectedManufacturers);

  const [filterLoading, setFilterLoading] = useState(true);

  const initializePage = () => {
    setDashboardTab();
    getFilters();
  };

  useEffect(initializePage
    //  eslint-disable-next-line
  , []);
  
  useEffect(() => {
    if (allFilters) {
      setFilterLoading(false);
    }
    //  eslint-disable-next-line
  }, [allFilters]);

  //eslint-disable-next-line
  useEffect(() => onApplySearch(), [selectedManufacturers]);

  //  eslint-disable-next-line  
  useEffect(() => onApplyDate(), [dashDateString, selectedManufacturers]);

  const hasFiltersSelected = () => {
    return (
      (selectedStates && selectedStates.length > 0) ||
      (selectedCategory && selectedCategory.length > 0) ||
      (selectedParentLocation && selectedParentLocation.length > 0) ||
      (selectedChildLocation && selectedChildLocation.length > 0) ||
      (selectedDistributor && selectedDistributor.length > 0) ||
      (selectedSegment && selectedSegment.length > 0)
    );
  };

  const clearAllFilters = () => {
    onChangeSelectedStates([]);
    onChangeSelectedCategories([]);
    onChangeSelectedLocations([]);
    onChangeSelectedChildrens([]);
    onChangeSelectedDistributors([]);
    onChangeSelectedSegments([]);
  };

  return (
    <>
      <PageHeader title='Dashboard' subtitle="Today's Highlights" icon={<BsFillGridFill fill='url(#icon-gradient)'/>}/>
      <Col className='p-3'>
        <Row className='label-text text-size-14 d-flex align-items-center mx-auto pb-2'>
          <Col className='ps-0'>
            <div className='main-header text-size-20' style={{lineHeight:'23px', fontWeight:'700',letterSpacing:'.0025em' }}>Today's Highlights</div>
          </Col>
          <Col className='col-auto ps-0 pe-0'>
            <Row>
              <Col>
                <ManufacturerSelect />
              </Col>
            </Row>
          </Col>
        </Row>
        <Row xs={1} md={1} lg={1} xl={1} className='label-text text-size-14 d-flex align-items-center card-row g-2'>
          <Card className='dashboard-card px-3' style={{height: '110px'}}>
            <HighlightsCard />
          </Card>
          <Card className='px-3 py-2' style={{ textWrap: 'nowrap', background: 'white', backgroundImage: 'url("./FiltersBackground.png")', backgroundSize: 'cover', backgroundRepeat: 'no-repeat'}}>
            <Col>
              <Row className='mb-2'>
                <div className="main-header text-size-20" style={{color: colors.blueFilter}}><FaFilter fontSize={'15px'} style={{marginBottom: '5px'}}/> Filters</div>
              </Row>
              <Row className='mb-2'>
                <Col style={{minWidth: '200px'}}>
                  <InputLabel style={{color: 'black', fontSize: '12px'}}>Select Date Range</InputLabel>
                  <DateRangePicker 
                    id='dashboardDateSearch'
                    defaultStartDate={moment(fromDate).format('MM/DD/YYYY')} 
                    defaultEndDate={moment(toDate).format('MM/DD/YYYY')} 
                    minDate={moment(minDate).format('MM/DD/YYYY')} 
                    maxDate={moment().format('MM/DD/YYYY')} 
                    callback={(start, end) => onChangeDashboardDates(start, end)}
                    ranges={{
                      'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                      'Last 2 Months': [moment().subtract(2, 'month'), moment()],
                      'Last Year': [moment().subtract(1, 'year'), moment()]
                      }
                    }
                  />
                </Col>
                <Col style={{minWidth: '200px'}}>
                  <InputLabel style={{color: 'black', fontSize: '12px'}}>Category</InputLabel>
                  <SelectAllSearch
                    placeholder='Select Category'
                    isMulti={true}
                    closeMenuOnSelect={false}
                    isLoading={filterLoading}
                    options={allFilters?.categories?.map((category) => ({value: category, label: category})) || []}
                    value={selectedCategory}
                    onChange={(category) => onChangeSelectedCategories(category)}
                  />
                </Col>
                <Col style={{minWidth: '200px'}}>
                  <InputLabel style={{color: 'black', fontSize: '12px'}}>Parent Location</InputLabel>
                  <SelectAllSearch
                    placeholder='Select Parent Location'
                    isMulti={true}
                    closeMenuOnSelect={false}
                    isLoading={filterLoading}
                    options={allFilters?.locations?.map((location) => ({value: location, label: location})) || []}
                    value={selectedParentLocation}
                    onChange={(location) => onChangeSelectedLocations(location)}
                  />
                </Col>
                <Col style={{minWidth: '200px'}}>
                  <InputLabel style={{color: 'black', fontSize: '12px'}}>Child Location</InputLabel>
                  <SelectAllSearch
                    placeholder='Select Child Location'
                    isMulti={true}
                    isDisabled={!selectedParentLocation || selectedParentLocation.length === 0}
                    closeMenuOnSelect={false}
                    isLoading={filterLoading}
                    options={childrenFilters?.map((child) => ({value: child, label: child})) || []}
                    value={selectedChildLocation}
                    onChange={(child) => onChangeSelectedChildrens(child)}
                  />
                </Col>
              </Row>
              <Row>
                <Col style={{minWidth: '200px'}}>
                  <InputLabel style={{color: 'black', fontSize: '12px'}}>Distributor</InputLabel>
                  <SelectAllSearch
                    placeholder='Select Distributor'
                    isMulti={true}
                    closeMenuOnSelect={false}
                    isLoading={filterLoading}
                    options={allFilters?.distributors?.map((distributor) => ({value: distributor, label: distributor})) || []}
                    value={selectedDistributor}
                    onChange={(distributor) => onChangeSelectedDistributors(distributor)}
                  />
                </Col>
                <Col style={{minWidth: '200px'}}>
                  <InputLabel style={{color: 'black', fontSize: '12px'}}>Customer Segment</InputLabel>
                  <SelectAllSearch
                    placeholder='Select Segment'
                    isMulti={true}
                    closeMenuOnSelect={false}
                    isLoading={filterLoading}
                    options={allFilters?.segments?.map((segment) => {
                      const segmentLabel = segment.split('_').map(w => w[0].toUpperCase() + w.substring(1).toLowerCase()).join(' ');
                      return {value: segment, label: segmentLabel};
                    }) || []}
                    value={selectedSegment}
                    onChange={(segment) => onChangeSelectedSegments(segment)}
                  />
                </Col>
                <Col style={{minWidth: '200px'}}>
                  <InputLabel style={{color: 'black', fontSize: '12px'}}>Select State/Territory</InputLabel>
                  <SelectAllSearch
                    isMulti={true}
                    closeMenuOnSelect={false}
                    name='state'
                    styles={selectStyles} 
                    options = {usStatesAndTerritoriesOptions}
                    onChange = {(e) => onChangeSelectedStates(e)}
                    value = {selectedStates}
                    placeholder='Select State/Territory'
                  />
                </Col>
              </Row>
              <Row className='mt-3'>
                <Col className='d-flex justify-content-end gap-2'>
                  {hasFiltersSelected() && (
                    <Button 
                      outline
                      color='mutedRed'
                      size='sm'
                      onClick={clearAllFilters}
                      style={{
                        padding: '6px 24px'
                      }}
                    >
                      Clear Filters
                    </Button>
                  )}
                  <Button 
                    color='blueFilter'
                    size='sm'
                    onClick={() => onApplySearch()}
                    style={{
                      color: 'white',
                      padding: '6px 24px'
                    }}
                  >
                    Apply Filters
                  </Button>
                </Col>
              </Row>
            </Col>
          </Card>
          <Card className='products-locations-card px-3' style={{maxHeight: '700px'}}>
            <ProductsLocationsCard />
          </Card>
          <Card className='dashboard-card px-3 py-1' style={{minHeight: '750px', height: '100%'}}>
            <DashboardChartsCard />
          </Card>
          <Card className='dashboard-card px-3' style={{minHeight: '450px'}}>
            <BEPDistributorListCard />
          </Card>
          <Card className='dashboard-card px-3' style={{minHeight: '450px'}}>
            <SegmentOverviewCard />
          </Card>
        </Row>
        <Row>
          <Col className=' w-fc ms-auto me-0'>
            <div className='text-beplBlue' style={{'display': (mfrName ? 'block' : 'none')}}>*All data is for {mfrName}</div>
          </Col>
        </Row>
        <SlideDrawer title={slideDrawerContents.title} drawerContents={slideDrawerContents.contents}/>
      </Col>
    </>
  );
}

export default Dashboard;
